import R from 'app/assets/R'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { BaseSelect } from 'app/components/common/selects/BaseSelect'
import { DepartmentsEnum } from 'app/containers/TradeUnionMemberManagement/type'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IFilterTradeUnionList } from '../../type'

interface IProps {
  onChangeFilter?: (filter: IFilterTradeUnionList) => void
  filter?: IFilterTradeUnionList
}

export const FilterLayout: React.FC<IProps> = ({ filter, onChangeFilter }) => {
  const { t } = useTranslation()

  const onChangeSearch = (value: string) => {
    onChangeFilter?.({ ...filter, search: value })
  }

  const onChangeDepartment = (value: DepartmentsEnum) => {
    onChangeFilter?.({ ...filter, unit: value })
  }

  const onChangeIsSync = (value: number) => {
    onChangeFilter?.({ ...filter, isSync: value })
  }

  return (
    <BaseForm>
      <BaseRow gutter={[16, 8]}>
        <BaseCol xl={8}>
          <BaseForm.Item hiddenLabel>
            <BaseInput
              placeholder={t(R.strings.search)}
              value={filter?.search}
              onChange={e => onChangeSearch?.(e?.target?.value)}
              allowClear
            />
          </BaseForm.Item>
        </BaseCol>
        <BaseCol xl={8}>
          <BaseForm.Item hiddenLabel>
            <BaseSelect
              placeholder="Chọn đơn vị công tác"
              options={Object.values(DepartmentsEnum).map(department => ({
                label: department,
                value: department,
              }))}
              showSearch
              onChange={(value) => onChangeDepartment(value as DepartmentsEnum)}
            />
          </BaseForm.Item>
        </BaseCol>
        <BaseCol xl={8}>
          <BaseForm.Item hiddenLabel>
            <BaseSelect
              placeholder="Chọn trạng thái đồng bộ"
              options={[
                { label: 'Được đồng bộ', value: 1 },
                { label: 'Không được đồng bộ', value: 0 },
              ]}
              showSearch
              onChange={(value) => onChangeIsSync(value as number)}
            />
          </BaseForm.Item>
        </BaseCol>
      </BaseRow>
    </BaseForm>
  )
}
